import { PRICE_SET_MAX, RECORDS_INITIAL_COUNT } from '../constants'

export const getRecords = ({ viewAllRecords, records = []}) =>
  viewAllRecords ? records : records.slice(0, RECORDS_INITIAL_COUNT)

export const getProductUniqueId = ({
  product: {
    attributes: {
      frontTire: [{ frontTireSkuId } = {}] = [],
      rearTire: [{ rearTireSkuId } = {}] = []
    } = {}
  } = {},
  index
}) =>
  rearTireSkuId ?
    `${rearTireSkuId}-${frontTireSkuId}-${index}` : `${frontTireSkuId}-${index}`

export const getGBBFilteredRecords = (records, gBBDetails) => records.filter(({
  attributes: {
    frontTire: [{ frontTireSkuId } = {}] = []
  } = {}
} = {}) => !(gBBDetails[frontTireSkuId]))

export const formatGBBProducts = (gBBDetails) => Object.keys(gBBDetails).map(key => ({ ...gBBDetails[key] }))

const getProductAttributes = ({
  attributes: {
    bvId: [bvId] = [],
    brandName: [brandName] = []
  } = {}
} = {}) => ({
  brandName,
  bvId
})

export const createProductsListForInventoryPayload = ({ visibleRecords, GBBDetails = []}) => {
  const defaultQuantityValue = PRICE_SET_MAX

  const uniqueProductsList = [...visibleRecords, ...GBBDetails].reduce((acc, curr) => {
    const currentAttributes = curr.attributes ? getProductAttributes({ attributes: curr.attributes }) : curr
    const isProductInAcc = acc.some(product => product.bvId === currentAttributes.bvId)

    if (isProductInAcc) {
      return [...acc]
    }

    return [...acc, {
      brand: currentAttributes.brandName,
      partNumber: currentAttributes.bvId,
      quantity: defaultQuantityValue
    }]
  }, [])

  return uniqueProductsList
}
